import { action, observable, runInAction } from 'mobx';
import { SessionStore } from './session.store';
import { AggregateFunction, AgtAnalyticsStore, SelectColumn } from './agt.analytics.store';
import { result } from 'lodash';

export interface IAgtLeadNowModel {
	vtnrId: number;
	kw: number;
	agenturstatus: string;

	// Individual abo counts
	avBrutto: number;
	avNetto: number;
	avStorno: number;

	avvermBrutto: number;
	avvermNetto: number;
	avvermStorno: number;

	baufiBrutto: number;
	baufiNetto: number;
	baufiStorno: number;

	bauspBrutto: number;
	bauspNetto: number;
	bauspStorno: number;

	buBrutto: number;
	buNetto: number;
	buStorno: number;

	fsachBrutto: number;
	fsachNetto: number;
	fsachStorno: number;

	kfzBrutto: number;
	kfzNetto: number;
	kfzStorno: number;

	kvBrutto: number;
	kvNetto: number;
	kvStorno: number;

	kzusBrutto: number;
	kzusNetto: number;
	kzusStorno: number;

	psachBrutto: number;
	psachNetto: number;
	psachStorno: number;

	reiseBrutto: number;
	reiseNetto: number;
	reiseStorno: number;

	tierBrutto: number;
	tierNetto: number;
	tierStorno: number;

	beratBrutto: number;
	beratNetto: number;
	beratStorno: number;

	vermBrutto: number;
	vermNetto: number;
	vermStorno: number;

	hbaBrutto: number;
	hbaNetto: number;
	hbaStorno: number;

	kwkBrutto: number;
	kwkNetto: number;
	kwkStorno: number;

	zulaBrutto: number;
	zulaNetto: number;
	zulaStorno: number;

	// Total counts
	totalBrutto: number;
	totalNetto: number;
	totalStorno: number;
}

export class AgtLeadNowModel implements IAgtLeadNowModel {
	vtnrId: number;
	kw: number;
	agenturstatus: string;

	avBrutto: number;
	avNetto: number;
	avStorno: number;

	avvermBrutto: number;
	avvermNetto: number;
	avvermStorno: number;

	baufiBrutto: number;
	baufiNetto: number;
	baufiStorno: number;

	bauspBrutto: number;
	bauspNetto: number;
	bauspStorno: number;

	buBrutto: number;
	buNetto: number;
	buStorno: number;

	fsachBrutto: number;
	fsachNetto: number;
	fsachStorno: number;

	kfzBrutto: number;
	kfzNetto: number;
	kfzStorno: number;

	kvBrutto: number;
	kvNetto: number;
	kvStorno: number;

	kzusBrutto: number;
	kzusNetto: number;
	kzusStorno: number;

	psachBrutto: number;
	psachNetto: number;
	psachStorno: number;

	reiseBrutto: number;
	reiseNetto: number;
	reiseStorno: number;

	tierBrutto: number;
	tierNetto: number;
	tierStorno: number;

	beratBrutto: number;
	beratNetto: number;
	beratStorno: number;

	vermBrutto: number;
	vermNetto: number;
	vermStorno: number;

	hbaBrutto: number;
	hbaNetto: number;
	hbaStorno: number;

	kwkBrutto: number;
	kwkNetto: number;
	kwkStorno: number;

	zulaBrutto: number;
	zulaNetto: number;
	zulaStorno: number;

	totalBrutto: number;
	totalNetto: number;
	totalStorno: number;

	// Legacy compatibility properties
	agtId: number;

	constructor(data: any) {
		this.vtnrId = data.aid || 0;
		this.kw = data.kw ? parseInt(data.kw) : 0;
		this.agenturstatus = data.as || '';

		this.avBrutto = data.av_b || 0;
		this.avNetto = data.av_n || 0;
		this.avStorno = data.av_s || 0;

		this.avvermBrutto = data.avverm_b || 0;
		this.avvermNetto = data.avverm_n || 0;
		this.avvermStorno = data.avverm_s || 0;

		this.baufiBrutto = data.baufi_b || 0;
		this.baufiNetto = data.baufi_n || 0;
		this.baufiStorno = data.baufi_s || 0;

		this.bauspBrutto = data.bausp_b || 0;
		this.bauspNetto = data.bausp_n || 0;
		this.bauspStorno = data.bausp_s || 0;

		this.buBrutto = data.bu_b || 0;
		this.buNetto = data.bu_n || 0;
		this.buStorno = data.bu_s || 0;

		this.fsachBrutto = data.fsach_b || 0;
		this.fsachNetto = data.fsach_n || 0;
		this.fsachStorno = data.fsach_s || 0;

		this.kfzBrutto = data.kfz_b || 0;
		this.kfzNetto = data.kfz_n || 0;
		this.kfzStorno = data.kfz_s || 0;

		this.kvBrutto = data.kv_b || 0;
		this.kvNetto = data.kv_n || 0;
		this.kvStorno = data.kv_s || 0;

		this.kzusBrutto = data.kzus_b || 0;
		this.kzusNetto = data.kzus_n || 0;
		this.kzusStorno = data.kzus_s || 0;

		this.psachBrutto = data.psach_b || 0;
		this.psachNetto = data.psach_n || 0;
		this.psachStorno = data.psach_s || 0;

		this.reiseBrutto = data.reise_b || 0;
		this.reiseNetto = data.reise_n || 0;
		this.reiseStorno = data.reise_s || 0;

		this.tierBrutto = data.tier_b || 0;
		this.tierNetto = data.tier_n || 0;
		this.tierStorno = data.tier_s || 0;

		this.beratBrutto = data.berat_b || 0;
		this.beratNetto = data.berat_n || 0;
		this.beratStorno = data.berat_s || 0;

		this.vermBrutto = data.verm_b || 0;
		this.vermNetto = data.verm_n || 0;
		this.vermStorno = data.verm_s || 0;

		this.hbaBrutto = data.hba_b || 0;
		this.hbaNetto = data.hba_n || 0;
		this.hbaStorno = data.hba_s || 0;

		this.kwkBrutto = data.kwk_b || 0;
		this.kwkNetto = data.kwk_n || 0;
		this.kwkStorno = data.kwk_s || 0;

		this.zulaBrutto = data.zula_b || 0;
		this.zulaNetto = data.zula_n || 0;
		this.zulaStorno = data.zula_s || 0;

		this.totalBrutto = data.total_b || 0;
		this.totalNetto = data.total_n || 0;
		this.totalStorno = data.total_s || 0;

		// Legacy compatibility - alias properties
		this.agtId = this.vtnrId;
	}
}

export class AgtLeadNowStore extends AgtAnalyticsStore {
	constructor(session: SessionStore) {
		super(session, {
			tableName: 'agentur_leadnow',
			defaultColumns: [
				{ column: 'vtnr_id', aggregateFunction: AggregateFunction.NONE, alias: 'aid' },
				{ column: 'kw', aggregateFunction: AggregateFunction.NONE },
				{ column: 'agenturstatus', aggregateFunction: AggregateFunction.NONE, alias: 'as' },

				// AV
				{ column: 'av_brutto', aggregateFunction: AggregateFunction.NONE, alias: 'av_b' },
				{ column: 'av_netto', aggregateFunction: AggregateFunction.NONE, alias: 'av_n' },
				{ column: 'av_storno', aggregateFunction: AggregateFunction.NONE, alias: 'av_s' },

				// AVVERM
				{ column: 'avverm_brutto', aggregateFunction: AggregateFunction.NONE, alias: 'avverm_b' },
				{ column: 'avverm_netto', aggregateFunction: AggregateFunction.NONE, alias: 'avverm_n' },
				{ column: 'avverm_storno', aggregateFunction: AggregateFunction.NONE, alias: 'avverm_s' },

				// BAUFI
				{ column: 'baufi_brutto', aggregateFunction: AggregateFunction.NONE, alias: 'baufi_b' },
				{ column: 'baufi_netto', aggregateFunction: AggregateFunction.NONE, alias: 'baufi_n' },
				{ column: 'baufi_storno', aggregateFunction: AggregateFunction.NONE, alias: 'baufi_s' },

				// BAUSP
				{ column: 'bausp_brutto', aggregateFunction: AggregateFunction.NONE, alias: 'bausp_b' },
				{ column: 'bausp_netto', aggregateFunction: AggregateFunction.NONE, alias: 'bausp_n' },
				{ column: 'bausp_storno', aggregateFunction: AggregateFunction.NONE, alias: 'bausp_s' },

				// BU
				{ column: 'bu_brutto', aggregateFunction: AggregateFunction.NONE, alias: 'bu_b' },
				{ column: 'bu_netto', aggregateFunction: AggregateFunction.NONE, alias: 'bu_n' },
				{ column: 'bu_storno', aggregateFunction: AggregateFunction.NONE, alias: 'bu_s' },

				// FSACH
				{ column: 'fsach_brutto', aggregateFunction: AggregateFunction.NONE, alias: 'fsach_b' },
				{ column: 'fsach_netto', aggregateFunction: AggregateFunction.NONE, alias: 'fsach_n' },
				{ column: 'fsach_storno', aggregateFunction: AggregateFunction.NONE, alias: 'fsach_s' },

				// KFZ
				{ column: 'kfz_brutto', aggregateFunction: AggregateFunction.NONE, alias: 'kfz_b' },
				{ column: 'kfz_netto', aggregateFunction: AggregateFunction.NONE, alias: 'kfz_n' },
				{ column: 'kfz_storno', aggregateFunction: AggregateFunction.NONE, alias: 'kfz_s' },

				// KV
				{ column: 'kv_brutto', aggregateFunction: AggregateFunction.NONE, alias: 'kv_b' },
				{ column: 'kv_netto', aggregateFunction: AggregateFunction.NONE, alias: 'kv_n' },
				{ column: 'kv_storno', aggregateFunction: AggregateFunction.NONE, alias: 'kv_s' },

				// KZUS
				{ column: 'kzus_brutto', aggregateFunction: AggregateFunction.NONE, alias: 'kzus_b' },
				{ column: 'kzus_netto', aggregateFunction: AggregateFunction.NONE, alias: 'kzus_n' },
				{ column: 'kzus_storno', aggregateFunction: AggregateFunction.NONE, alias: 'kzus_s' },

				// PSACH
				{ column: 'psach_brutto', aggregateFunction: AggregateFunction.NONE, alias: 'psach_b' },
				{ column: 'psach_netto', aggregateFunction: AggregateFunction.NONE, alias: 'psach_n' },
				{ column: 'psach_storno', aggregateFunction: AggregateFunction.NONE, alias: 'psach_s' },

				// REISE
				{ column: 'reise_brutto', aggregateFunction: AggregateFunction.NONE, alias: 'reise_b' },
				{ column: 'reise_netto', aggregateFunction: AggregateFunction.NONE, alias: 'reise_n' },
				{ column: 'reise_storno', aggregateFunction: AggregateFunction.NONE, alias: 'reise_s' },

				// TIER
				{ column: 'tier_brutto', aggregateFunction: AggregateFunction.NONE, alias: 'tier_b' },
				{ column: 'tier_netto', aggregateFunction: AggregateFunction.NONE, alias: 'tier_n' },
				{ column: 'tier_storno', aggregateFunction: AggregateFunction.NONE, alias: 'tier_s' },

				// BERAT
				{ column: 'berat_brutto', aggregateFunction: AggregateFunction.NONE, alias: 'berat_b' },
				{ column: 'berat_netto', aggregateFunction: AggregateFunction.NONE, alias: 'berat_n' },
				{ column: 'berat_storno', aggregateFunction: AggregateFunction.NONE, alias: 'berat_s' },

				// VERM
				{ column: 'verm_brutto', aggregateFunction: AggregateFunction.NONE, alias: 'verm_b' },
				{ column: 'verm_netto', aggregateFunction: AggregateFunction.NONE, alias: 'verm_n' },
				{ column: 'verm_storno', aggregateFunction: AggregateFunction.NONE, alias: 'verm_s' },

				// HBA
				{ column: 'hba_brutto', aggregateFunction: AggregateFunction.NONE, alias: 'hba_b' },
				{ column: 'hba_netto', aggregateFunction: AggregateFunction.NONE, alias: 'hba_n' },
				{ column: 'hba_storno', aggregateFunction: AggregateFunction.NONE, alias: 'hba_s' },

				// ZULA
				{ column: 'zula_brutto', aggregateFunction: AggregateFunction.NONE, alias: 'zula_b' },
				{ column: 'zula_netto', aggregateFunction: AggregateFunction.NONE, alias: 'zula_n' },
				{ column: 'zula_storno', aggregateFunction: AggregateFunction.NONE, alias: 'zula_s' },

				// TOTALS
				{ column: 'total_brutto', aggregateFunction: AggregateFunction.NONE, alias: 'total_b' },
				{ column: 'total_netto', aggregateFunction: AggregateFunction.NONE, alias: 'total_n' },
				{ column: 'total_storno', aggregateFunction: AggregateFunction.NONE, alias: 'total_s' },
			],
		});
		this.queryName = '?leadNow';
	}

	async getDistinctKWs(): Promise<number[]> {
		const selectColumns: SelectColumn[] = [
			{ column: 'kw', aggregateFunction: AggregateFunction.NONE, distinct: true },
		];
		const results = await this.query(selectColumns);
		return results.map(data => parseInt(data.kw)).sort((a, b) => a - b);
	}

	@action
	async loadWeeklyByAgt(agtId: number): Promise<AgtLeadNowModel[]> {
		const year = new Date().getFullYear();
		const minKw = year * 100 + 1;
		const maxKw = year * 100 + 53;
		const whereClause = `vtnr_id = ${agtId} AND kw BETWEEN ${minKw} AND ${maxKw}`;
		const results = await this.query(this.config.defaultColumns, whereClause);
		return results.map(data => new AgtLeadNowModel(data)).sort((a, b) => a.kw - b.kw);
	}

	@action
	async loadByKw(kw: number): Promise<AgtLeadNowModel[]> {
		let whereClause = 'kw = ' + kw;
		const results = await this.query(this.config.defaultColumns, whereClause);
		return results.map(data => new AgtLeadNowModel(data));
	}

	@action
	async loadByMaxKw(): Promise<AgtLeadNowModel[]> {
		const maxKwPerAgt: { aid: number; kw: number }[] = await this.query([
			{ column: 'vtnr_id', aggregateFunction: AggregateFunction.NONE, groupBy: true, alias: 'aid' },
			{ column: 'kw', aggregateFunction: AggregateFunction.MAX, alias: 'kw' },
		]);
		if (maxKwPerAgt.length === 0) return [];

		const tuples = maxKwPerAgt
			.filter(r => r.aid && r.kw)
			.map(r => `(${r.aid}, ${r.kw})`)
			.join(', ');
		const whereClause = `(vtnr_id, kw) IN (${tuples})`;
		const results = await this.query(this.config.defaultColumns, whereClause);
		return results.map(data => new AgtLeadNowModel(data));
	}


	@action
	async aggregateByKwRange(minKw: number, maxKw: number): Promise<AgtLeadNowModel[]> {
		let whereClause = `kw BETWEEN ${minKw} AND ${maxKw}`;

		// Build columns with SUM aggregation for all numeric fields
		const selectColumns: SelectColumn[] = [
			{ column: 'vtnr_id', aggregateFunction: AggregateFunction.NONE, groupBy: true, alias: 'aid' },
			// Get the max KW for this agency in the range
			{ column: 'kw', aggregateFunction: AggregateFunction.MAX, alias: 'kw' },

			// AV
			{ column: 'av_brutto', aggregateFunction: AggregateFunction.SUM, alias: 'av_b' },
			{ column: 'av_netto', aggregateFunction: AggregateFunction.SUM, alias: 'av_n' },
			{ column: 'av_storno', aggregateFunction: AggregateFunction.SUM, alias: 'av_s' },

			// AVVERM
			{ column: 'avverm_brutto', aggregateFunction: AggregateFunction.SUM, alias: 'avverm_b' },
			{ column: 'avverm_netto', aggregateFunction: AggregateFunction.SUM, alias: 'avverm_n' },
			{ column: 'avverm_storno', aggregateFunction: AggregateFunction.SUM, alias: 'avverm_s' },

			// BAUFI
			{ column: 'baufi_brutto', aggregateFunction: AggregateFunction.SUM, alias: 'baufi_b' },
			{ column: 'baufi_netto', aggregateFunction: AggregateFunction.SUM, alias: 'baufi_n' },
			{ column: 'baufi_storno', aggregateFunction: AggregateFunction.SUM, alias: 'baufi_s' },

			// BAUSP
			{ column: 'bausp_brutto', aggregateFunction: AggregateFunction.SUM, alias: 'bausp_b' },
			{ column: 'bausp_netto', aggregateFunction: AggregateFunction.SUM, alias: 'bausp_n' },
			{ column: 'bausp_storno', aggregateFunction: AggregateFunction.SUM, alias: 'bausp_s' },

			// BU
			{ column: 'bu_brutto', aggregateFunction: AggregateFunction.SUM, alias: 'bu_b' },
			{ column: 'bu_netto', aggregateFunction: AggregateFunction.SUM, alias: 'bu_n' },
			{ column: 'bu_storno', aggregateFunction: AggregateFunction.SUM, alias: 'bu_s' },

			// FSACH
			{ column: 'fsach_brutto', aggregateFunction: AggregateFunction.SUM, alias: 'fsach_b' },
			{ column: 'fsach_netto', aggregateFunction: AggregateFunction.SUM, alias: 'fsach_n' },
			{ column: 'fsach_storno', aggregateFunction: AggregateFunction.SUM, alias: 'fsach_s' },

			// KFZ
			{ column: 'kfz_brutto', aggregateFunction: AggregateFunction.SUM, alias: 'kfz_b' },
			{ column: 'kfz_netto', aggregateFunction: AggregateFunction.SUM, alias: 'kfz_n' },
			{ column: 'kfz_storno', aggregateFunction: AggregateFunction.SUM, alias: 'kfz_s' },

			// KV
			{ column: 'kv_brutto', aggregateFunction: AggregateFunction.SUM, alias: 'kv_b' },
			{ column: 'kv_netto', aggregateFunction: AggregateFunction.SUM, alias: 'kv_n' },
			{ column: 'kv_storno', aggregateFunction: AggregateFunction.SUM, alias: 'kv_s' },

			// KZUS
			{ column: 'kzus_brutto', aggregateFunction: AggregateFunction.SUM, alias: 'kzus_b' },
			{ column: 'kzus_netto', aggregateFunction: AggregateFunction.SUM, alias: 'kzus_n' },
			{ column: 'kzus_storno', aggregateFunction: AggregateFunction.SUM, alias: 'kzus_s' },

			// PSACH
			{ column: 'psach_brutto', aggregateFunction: AggregateFunction.SUM, alias: 'psach_b' },
			{ column: 'psach_netto', aggregateFunction: AggregateFunction.SUM, alias: 'psach_n' },
			{ column: 'psach_storno', aggregateFunction: AggregateFunction.SUM, alias: 'psach_s' },

			// REISE
			{ column: 'reise_brutto', aggregateFunction: AggregateFunction.SUM, alias: 'reise_b' },
			{ column: 'reise_netto', aggregateFunction: AggregateFunction.SUM, alias: 'reise_n' },
			{ column: 'reise_storno', aggregateFunction: AggregateFunction.SUM, alias: 'reise_s' },

			// TIER
			{ column: 'tier_brutto', aggregateFunction: AggregateFunction.SUM, alias: 'tier_b' },
			{ column: 'tier_netto', aggregateFunction: AggregateFunction.SUM, alias: 'tier_n' },
			{ column: 'tier_storno', aggregateFunction: AggregateFunction.SUM, alias: 'tier_s' },

			// BERAT
			{ column: 'berat_brutto', aggregateFunction: AggregateFunction.SUM, alias: 'berat_b' },
			{ column: 'berat_netto', aggregateFunction: AggregateFunction.SUM, alias: 'berat_n' },
			{ column: 'berat_storno', aggregateFunction: AggregateFunction.SUM, alias: 'berat_s' },

			// VERM
			{ column: 'verm_brutto', aggregateFunction: AggregateFunction.SUM, alias: 'verm_b' },
			{ column: 'verm_netto', aggregateFunction: AggregateFunction.SUM, alias: 'verm_n' },
			{ column: 'verm_storno', aggregateFunction: AggregateFunction.SUM, alias: 'verm_s' },

			// HBA
			{ column: 'hba_brutto', aggregateFunction: AggregateFunction.SUM, alias: 'hba_b' },
			{ column: 'hba_netto', aggregateFunction: AggregateFunction.SUM, alias: 'hba_n' },
			{ column: 'hba_storno', aggregateFunction: AggregateFunction.SUM, alias: 'hba_s' },
			// kwk
			{ column: 'kwk_brutto', aggregateFunction: AggregateFunction.SUM, alias: 'kwk_b' },
			{ column: 'kwk_netto', aggregateFunction: AggregateFunction.SUM, alias: 'kwk_n' },
			{ column: 'kwk_storno', aggregateFunction: AggregateFunction.SUM, alias: 'kwk_s' },

			// ZULA
			{ column: 'zula_brutto', aggregateFunction: AggregateFunction.SUM, alias: 'zula_b' },
			{ column: 'zula_netto', aggregateFunction: AggregateFunction.SUM, alias: 'zula_n' },
			{ column: 'zula_storno', aggregateFunction: AggregateFunction.SUM, alias: 'zula_s' },

			{ column: 'agenturstatus', aggregateFunction: AggregateFunction.MAX, alias: 'as' },

			// TOTALS
			{ column: 'total_brutto', aggregateFunction: AggregateFunction.SUM, alias: 'total_b' },
			{ column: 'total_netto', aggregateFunction: AggregateFunction.SUM, alias: 'total_n' },
			{ column: 'total_storno', aggregateFunction: AggregateFunction.SUM, alias: 'total_s' },
		];

		const results = await this.query(selectColumns, whereClause);
		return results.map(data => new AgtLeadNowModel(data));

		// // For aggregated results, we need to fetch the agenturstatus separately
		// // We'll get it from the most recent KW for each agency
		// const resultsWithStatus = await Promise.all(results.map(async (data) => {
		// 	// Get the most recent status for this agency in the range
		// 	const statusQuery: SelectColumn[] = [
		// 		{ column: 'agenturstatus', aggregateFunction: AggregateFunction.NONE, alias: 'as' },
		// 	];
		// 	const statusWhere = `vtnr_id = ${data.aid} AND kw = ${data.kw}`;
		// 	const statusResults = await this.query(statusQuery, statusWhere);

		// 	return {
		// 		...data,
		// 		as: statusResults.length > 0 ? statusResults[0].as : '',
		// 	};
		// }));

		// return resultsWithStatus.map(results => new AgtLeadNowModel(data));
	}
}
